import { MapPin, Phone, Mail, ArrowUpRight } from "lucide-react";

const LOGO =
  "https://customer-assets.emergentagent.com/job_ea29b796-903f-4580-bdca-2f501b22a9b8/artifacts/62l7s6as_Lex%20Balance%20Perfecto.png";

export const Footer = () => {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#17351D] text-white pt-20 md:pt-28 pb-10 overflow-hidden"
    >
      {/* */}

      <div className="relative max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-10 md:gap-16 pb-16 border-b border-white/10">
          <div className="col-span-12 md:col-span-5">
            <div className="flex items-center mb-8">
              <img
                src={LOGO}
                alt="Lex Balance Perfecto"
                className="h-20 w-auto object-contain"
                style={{ filter: "brightness(0) invert(1)" }}
              />
            </div>
            <p className="text-white/60 leading-relaxed max-w-md">
              Organización financiera especializada en auditorías a despachos,
              notarías públicas, bufetes jurídicos y clientes particulares.
            </p>
          </div>

          <div className="col-span-12 md:col-span-4">
            <div className="overline text-[#C1C82A] mb-6">Contacto</div>
            <ul className="space-y-5 text-white/75">
              <li className="flex items-start gap-4">
                <MapPin size={16} className="mt-1 text-[#C1C82A] shrink-0" />
                <span className="leading-relaxed">
                  Calle Topografos 635, int. 2, Arcos de Guadalupe, C.P. 45037,
                  Zapopan, Jalisco, México.
                </span>
              </li>
              <li className="flex items-center gap-4">
                <Phone size={16} className="text-[#C1C82A] shrink-0" />
                <a
                  href="tel:+523312797811"
                  data-testid="footer-phone-link"
                  className="hover:text-white transition-colors"
                >
                  33 1 279 7811
                </a>
              </li>
              <li className="flex items-center gap-4">
                <Mail size={16} className="text-[#C1C82A] shrink-0" />
                <a
                  href="mailto:contacto@lexbalanceperfecto.com"
                  data-testid="footer-email-link"
                  className="hover:text-white transition-colors break-all"
                >
                  contacto@lexbalanceperfecto.com
                </a>
              </li>
            </ul>
          </div>

          <div className="col-span-12 md:col-span-3">
            <div className="overline text-[#C1C82A] mb-6">Navega</div>
            <ul className="space-y-3 text-white/75">
              {[
                ["Nosotros", "nosotros"],
                ["Distintivos", "principios"],
                ["Servicios", "servicios"],
                ["Clientes", "diferenciadores"],
                ["Contacto", "contacto"],
              ].map(([label, id]) => (
                <li key={id}>
                  <button
                    data-testid={`footer-link-${id}`}
                    onClick={() =>
                      document
                        .getElementById(id)
                        ?.scrollIntoView({ behavior: "smooth" })
                    }
                    className="hover:text-[#C1C82A] transition-colors"
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>

            <button
              data-testid="footer-back-to-top"
              onClick={scrollTop}
              className="mt-10 inline-flex items-center gap-3 text-[12px] tracking-[0.22em] uppercase text-white border-b border-[#C1C82A] pb-2 hover:text-[#C1C82A] transition-colors"
            >
              Volver arriba
              <ArrowUpRight size={14} strokeWidth={2.4} />
            </button>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-[11px] tracking-[0.2em] uppercase text-white/40">
          <span>© {new Date().getFullYear()} Lex Balance Perfecto. Todos los derechos reservados.</span>
          <span>lexbalanceperfecto.com</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
